
define('text!views/secured/help/help.html',[],function () { return '<section id="content-help">\r\n    \r\n</section>\r\n';});

